"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORTS_ERROR_TEXT = exports.REPORTS_ERROR_TITLE = exports.ASYNC_REPORTS_SUCCESS_TEXT = exports.ASYNC_REPORTS_SUCCESS_TITLE = exports.ASYNC_REPORTS_POPOVER_TEXT = void 0;
exports.ASYNC_REPORTS_POPOVER_TEXT = `This report will be available under the Output Files section after processing. We'll notify you by email when it's ready.`;
exports.ASYNC_REPORTS_SUCCESS_TITLE = "Upload Started";
exports.ASYNC_REPORTS_SUCCESS_TEXT = `Your file is being generated. We'll email you when it's ready for download.`;
exports.REPORTS_ERROR_TITLE = "Error";
exports.REPORTS_ERROR_TEXT = "Sorry, the report is currently unavailable.";
